/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as ChangePasswordRouteImport } from './routes/change-password'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as TwoFactorRouteImport } from './routes/two-factor'
import { Route as AuthenticatedDataRouteImport } from './routes/_authenticated/data'
import { Route as AuthenticatedDataQualityRouteImport } from './routes/_authenticated/data-quality'
import { Route as AuthenticatedGapWorkbookUploadsRouteImport } from './routes/_authenticated/gap-workbook-uploads'
import { Route as AuthenticatedNoAccessRouteImport } from './routes/_authenticated/no-access'
import { Route as AuthenticatedPlaygroundRouteImport } from './routes/_authenticated/playground'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedAcoAcoCodeRouteImport } from './routes/_authenticated/aco/$acoCode'
import { Route as AuthenticatedAdminAuditRouteImport } from './routes/_authenticated/admin/audit'
import { Route as AuthenticatedAdminUsersRouteImport } from './routes/_authenticated/admin/users'
import { Route as AuthenticatedGroupsIndexRouteImport } from './routes/_authenticated/groups/index'
import { Route as AuthenticatedGroupsGroupIdRouteImport } from './routes/_authenticated/groups/$groupId'
import { Route as AuthenticatedPracticeIndexRouteImport } from './routes/_authenticated/practice/index'
import { Route as AuthenticatedSettingsPasswordRouteImport } from './routes/_authenticated/settings_.password'
import { Route as AuthenticatedPracticeGapsIndexRouteImport } from './routes/_authenticated/practice/gaps/index'
import { Route as AuthenticatedDataBundlesBundleIdLoadRouteImport } from './routes/_authenticated/data/bundles/$bundleId/load'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangePasswordRoute = ChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const TwoFactorRoute = TwoFactorRouteImport.update({
  id: '/two-factor',
  path: '/two-factor',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedDataRoute = AuthenticatedDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDataQualityRoute =
  AuthenticatedDataQualityRouteImport.update({
    id: '/data-quality',
    path: '/data-quality',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGapWorkbookUploadsRoute =
  AuthenticatedGapWorkbookUploadsRouteImport.update({
    id: '/gap-workbook-uploads',
    path: '/gap-workbook-uploads',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNoAccessRoute = AuthenticatedNoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPlaygroundRoute = AuthenticatedPlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAcoAcoCodeRoute = AuthenticatedAcoAcoCodeRouteImport.update({
  id: '/aco/$acoCode',
  path: '/aco/$acoCode',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminAuditRoute = AuthenticatedAdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminUsersRoute = AuthenticatedAdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGroupsIndexRoute =
  AuthenticatedGroupsIndexRouteImport.update({
    id: '/groups/',
    path: '/groups/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGroupsGroupIdRoute =
  AuthenticatedGroupsGroupIdRouteImport.update({
    id: '/groups/$groupId',
    path: '/groups/$groupId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPracticeIndexRoute =
  AuthenticatedPracticeIndexRouteImport.update({
    id: '/practice/',
    path: '/practice/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsPasswordRoute =
  AuthenticatedSettingsPasswordRouteImport.update({
    id: '/settings_/password',
    path: '/settings/password',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPracticeGapsIndexRoute =
  AuthenticatedPracticeGapsIndexRouteImport.update({
    id: '/practice/gaps/',
    path: '/practice/gaps/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDataBundlesBundleIdLoadRoute =
  AuthenticatedDataBundlesBundleIdLoadRouteImport.update({
    id: '/bundles/$bundleId/load',
    path: '/bundles/$bundleId/load',
    getParentRoute: () => AuthenticatedDataRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/two-factor': typeof TwoFactorRoute
  '/data': typeof AuthenticatedDataRouteWithChildren
  '/data-quality': typeof AuthenticatedDataQualityRoute
  '/gap-workbook-uploads': typeof AuthenticatedGapWorkbookUploadsRoute
  '/no-access': typeof AuthenticatedNoAccessRoute
  '/playground': typeof AuthenticatedPlaygroundRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/aco/$acoCode': typeof AuthenticatedAcoAcoCodeRoute
  '/admin/audit': typeof AuthenticatedAdminAuditRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/groups/$groupId': typeof AuthenticatedGroupsGroupIdRoute
  '/settings/password': typeof AuthenticatedSettingsPasswordRoute
  '/groups/': typeof AuthenticatedGroupsIndexRoute
  '/practice/': typeof AuthenticatedPracticeIndexRoute
  '/practice/gaps/': typeof AuthenticatedPracticeGapsIndexRoute
  '/data/bundles/$bundleId/load': typeof AuthenticatedDataBundlesBundleIdLoadRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/change-password': typeof ChangePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/two-factor': typeof TwoFactorRoute
  '/data': typeof AuthenticatedDataRouteWithChildren
  '/data-quality': typeof AuthenticatedDataQualityRoute
  '/gap-workbook-uploads': typeof AuthenticatedGapWorkbookUploadsRoute
  '/no-access': typeof AuthenticatedNoAccessRoute
  '/playground': typeof AuthenticatedPlaygroundRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/aco/$acoCode': typeof AuthenticatedAcoAcoCodeRoute
  '/admin/audit': typeof AuthenticatedAdminAuditRoute
  '/admin/users': typeof AuthenticatedAdminUsersRoute
  '/groups/$groupId': typeof AuthenticatedGroupsGroupIdRoute
  '/settings/password': typeof AuthenticatedSettingsPasswordRoute
  '/groups': typeof AuthenticatedGroupsIndexRoute
  '/practice': typeof AuthenticatedPracticeIndexRoute
  '/practice/gaps': typeof AuthenticatedPracticeGapsIndexRoute
  '/data/bundles/$bundleId/load': typeof AuthenticatedDataBundlesBundleIdLoadRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/change-password': typeof ChangePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/two-factor': typeof TwoFactorRoute
  '/_authenticated/data': typeof AuthenticatedDataRouteWithChildren
  '/_authenticated/data-quality': typeof AuthenticatedDataQualityRoute
  '/_authenticated/gap-workbook-uploads': typeof AuthenticatedGapWorkbookUploadsRoute
  '/_authenticated/no-access': typeof AuthenticatedNoAccessRoute
  '/_authenticated/playground': typeof AuthenticatedPlaygroundRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/aco/$acoCode': typeof AuthenticatedAcoAcoCodeRoute
  '/_authenticated/admin/audit': typeof AuthenticatedAdminAuditRoute
  '/_authenticated/admin/users': typeof AuthenticatedAdminUsersRoute
  '/_authenticated/groups/$groupId': typeof AuthenticatedGroupsGroupIdRoute
  '/_authenticated/settings_/password': typeof AuthenticatedSettingsPasswordRoute
  '/_authenticated/groups/': typeof AuthenticatedGroupsIndexRoute
  '/_authenticated/practice/': typeof AuthenticatedPracticeIndexRoute
  '/_authenticated/practice/gaps/': typeof AuthenticatedPracticeGapsIndexRoute
  '/_authenticated/data/bundles/$bundleId/load': typeof AuthenticatedDataBundlesBundleIdLoadRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/change-password'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/two-factor'
    | '/data'
    | '/data-quality'
    | '/gap-workbook-uploads'
    | '/no-access'
    | '/playground'
    | '/settings'
    | '/aco/$acoCode'
    | '/admin/audit'
    | '/admin/users'
    | '/groups/$groupId'
    | '/settings/password'
    | '/groups/'
    | '/practice/'
    | '/practice/gaps/'
    | '/data/bundles/$bundleId/load'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/change-password'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/two-factor'
    | '/data'
    | '/data-quality'
    | '/gap-workbook-uploads'
    | '/no-access'
    | '/playground'
    | '/settings'
    | '/aco/$acoCode'
    | '/admin/audit'
    | '/admin/users'
    | '/groups/$groupId'
    | '/settings/password'
    | '/groups'
    | '/practice'
    | '/practice/gaps'
    | '/data/bundles/$bundleId/load'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/change-password'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/two-factor'
    | '/_authenticated/data'
    | '/_authenticated/data-quality'
    | '/_authenticated/gap-workbook-uploads'
    | '/_authenticated/no-access'
    | '/_authenticated/playground'
    | '/_authenticated/settings'
    | '/_authenticated/aco/$acoCode'
    | '/_authenticated/admin/audit'
    | '/_authenticated/admin/users'
    | '/_authenticated/groups/$groupId'
    | '/_authenticated/settings_/password'
    | '/_authenticated/groups/'
    | '/_authenticated/practice/'
    | '/_authenticated/practice/gaps/'
    | '/_authenticated/data/bundles/$bundleId/load'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ChangePasswordRoute: typeof ChangePasswordRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TwoFactorRoute: typeof TwoFactorRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/change-password': {
      id: '/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof ChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/two-factor': {
      id: '/two-factor'
      path: '/two-factor'
      fullPath: '/two-factor'
      preLoaderRoute: typeof TwoFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/data': {
      id: '/_authenticated/data'
      path: '/data'
      fullPath: '/data'
      preLoaderRoute: typeof AuthenticatedDataRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/data-quality': {
      id: '/_authenticated/data-quality'
      path: '/data-quality'
      fullPath: '/data-quality'
      preLoaderRoute: typeof AuthenticatedDataQualityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/gap-workbook-uploads': {
      id: '/_authenticated/gap-workbook-uploads'
      path: '/gap-workbook-uploads'
      fullPath: '/gap-workbook-uploads'
      preLoaderRoute: typeof AuthenticatedGapWorkbookUploadsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/no-access': {
      id: '/_authenticated/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof AuthenticatedNoAccessRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/playground': {
      id: '/_authenticated/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof AuthenticatedPlaygroundRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/aco/$acoCode': {
      id: '/_authenticated/aco/$acoCode'
      path: '/aco/$acoCode'
      fullPath: '/aco/$acoCode'
      preLoaderRoute: typeof AuthenticatedAcoAcoCodeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/audit': {
      id: '/_authenticated/admin/audit'
      path: '/admin/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AuthenticatedAdminAuditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/users': {
      id: '/_authenticated/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthenticatedAdminUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/groups/': {
      id: '/_authenticated/groups/'
      path: '/groups'
      fullPath: '/groups/'
      preLoaderRoute: typeof AuthenticatedGroupsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/groups/$groupId': {
      id: '/_authenticated/groups/$groupId'
      path: '/groups/$groupId'
      fullPath: '/groups/$groupId'
      preLoaderRoute: typeof AuthenticatedGroupsGroupIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/practice/': {
      id: '/_authenticated/practice/'
      path: '/practice'
      fullPath: '/practice/'
      preLoaderRoute: typeof AuthenticatedPracticeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings_/password': {
      id: '/_authenticated/settings_/password'
      path: '/settings/password'
      fullPath: '/settings/password'
      preLoaderRoute: typeof AuthenticatedSettingsPasswordRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/practice/gaps/': {
      id: '/_authenticated/practice/gaps/'
      path: '/practice/gaps'
      fullPath: '/practice/gaps/'
      preLoaderRoute: typeof AuthenticatedPracticeGapsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/data/bundles/$bundleId/load': {
      id: '/_authenticated/data/bundles/$bundleId/load'
      path: '/bundles/$bundleId/load'
      fullPath: '/data/bundles/$bundleId/load'
      preLoaderRoute: typeof AuthenticatedDataBundlesBundleIdLoadRouteImport
      parentRoute: typeof AuthenticatedDataRoute
    }
  }
}

interface AuthenticatedDataRouteChildren {
  AuthenticatedDataBundlesBundleIdLoadRoute: typeof AuthenticatedDataBundlesBundleIdLoadRoute
}

const AuthenticatedDataRouteChildren: AuthenticatedDataRouteChildren = {
  AuthenticatedDataBundlesBundleIdLoadRoute:
    AuthenticatedDataBundlesBundleIdLoadRoute,
}

const AuthenticatedDataRouteWithChildren =
  AuthenticatedDataRoute._addFileChildren(AuthenticatedDataRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedDataRoute: typeof AuthenticatedDataRouteWithChildren
  AuthenticatedDataQualityRoute: typeof AuthenticatedDataQualityRoute
  AuthenticatedGapWorkbookUploadsRoute: typeof AuthenticatedGapWorkbookUploadsRoute
  AuthenticatedNoAccessRoute: typeof AuthenticatedNoAccessRoute
  AuthenticatedPlaygroundRoute: typeof AuthenticatedPlaygroundRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedAcoAcoCodeRoute: typeof AuthenticatedAcoAcoCodeRoute
  AuthenticatedAdminAuditRoute: typeof AuthenticatedAdminAuditRoute
  AuthenticatedAdminUsersRoute: typeof AuthenticatedAdminUsersRoute
  AuthenticatedGroupsGroupIdRoute: typeof AuthenticatedGroupsGroupIdRoute
  AuthenticatedSettingsPasswordRoute: typeof AuthenticatedSettingsPasswordRoute
  AuthenticatedGroupsIndexRoute: typeof AuthenticatedGroupsIndexRoute
  AuthenticatedPracticeIndexRoute: typeof AuthenticatedPracticeIndexRoute
  AuthenticatedPracticeGapsIndexRoute: typeof AuthenticatedPracticeGapsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDataRoute: AuthenticatedDataRouteWithChildren,
  AuthenticatedDataQualityRoute: AuthenticatedDataQualityRoute,
  AuthenticatedGapWorkbookUploadsRoute: AuthenticatedGapWorkbookUploadsRoute,
  AuthenticatedNoAccessRoute: AuthenticatedNoAccessRoute,
  AuthenticatedPlaygroundRoute: AuthenticatedPlaygroundRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedAcoAcoCodeRoute: AuthenticatedAcoAcoCodeRoute,
  AuthenticatedAdminAuditRoute: AuthenticatedAdminAuditRoute,
  AuthenticatedAdminUsersRoute: AuthenticatedAdminUsersRoute,
  AuthenticatedGroupsGroupIdRoute: AuthenticatedGroupsGroupIdRoute,
  AuthenticatedSettingsPasswordRoute: AuthenticatedSettingsPasswordRoute,
  AuthenticatedGroupsIndexRoute: AuthenticatedGroupsIndexRoute,
  AuthenticatedPracticeIndexRoute: AuthenticatedPracticeIndexRoute,
  AuthenticatedPracticeGapsIndexRoute: AuthenticatedPracticeGapsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ChangePasswordRoute: ChangePasswordRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TwoFactorRoute: TwoFactorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
